import React, { useState } from "react";
import Topnavbar from "../dashboard/topnavbar";
import Sidennav from "../dashboard/sidenavbar";
import axios from "axios";
import { baseurladdress } from "../baseurl";

const CvUpload = () => {
  const accesstoken = localStorage.getItem("token");
  const [file, setFile] = useState(null);
  const [name, setName] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = (e) => {
    e.preventDefault();

    if (!file || !name.trim()) {
      alert("Please enter your name and select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("cv", file);
    formData.append("name", name); // send name too

    axios
      .post(baseurladdress + `uploadcv`, formData, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        alert("Upload successful!");
        console.log(res.data);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        alert("Upload failed!");
      });
  };

  return (
    <>
      <Topnavbar />
      <Sidennav />
      <div className="content-wrap">
        <div className="main">
          <div className="container-fluid">
            <section id="main-content">
              <div className="card">
                <div className="card-header" style={{ color: "black" }}>
                  <h6 className="card-title">Upload Your CV</h6>
                </div>

                <div className="card-body">
                  <div
                    style={{
                      maxWidth: "400px",
                      margin: "0 auto",
                      textAlign: "center",
                    }}
                  >
                    <form onSubmit={handleUpload}>
                      {/* Name input */}
                      <input
                        type="text"
                        placeholder="Enter your name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="form-control"
                        required
                      />
                      <br />

                      {/* CV upload */}
                      <input
                        type="file"
                        accept=".pdf,.doc,.docx"
                        onChange={handleFileChange}
                        className="form-control"
                        required
                      />
                      <br />

                      <button type="submit" className="btn btn-primary">
                        Upload
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CvUpload;
